import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === "development"
    ? "https://api.shahapaintandchemicals.com/api"
    : "https://api.shahapaintandchemicals.com/api"),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminhub_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("adminhub_token");
      localStorage.removeItem("adminhub_admin");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
